import { v4 } from 'uuid';
import { getStorageItem, setStorageItem } from '@/utils/localStorage';

export function getOrSetUUID() {
  const stored = getStorageItem('uuid');

  if (stored) return stored;

  const id = v4();
  setStorageItem('uuid', id);
  return id;
}
